import React, { MutableRefObject } from "react";

export interface Props {
  reference: MutableRefObject<any>;
}

const PrintingErrorAnimation: React.FC<Props> = ({ reference }) => {
  return (
    <div
      ref={reference}
      className="dqm-tcui-printing-error-animation dqm-tcui-printing-failed-message"
    >
      <div className="dqm-tcui-printing-animation__overlay dqm-tcui-printing-failed__overlay">
        <h1 className="dqm-tcui-printing-failed_container__title">
          Tulostusvirhe!
        </h1>
        <div className="dqm-tcui-printing-failed_container__text">
          <p>Ole hyvä ja ota yhteyttä henkilökuntaan</p>
        </div>
      </div>
    </div>
  );
};

export default PrintingErrorAnimation;
